import { useState } from 'react';
import SectionShell from './SectionShell';
import useSectionSetup from './useSectionSetup';
import SectionHeader from './SectionHeader';
import { hexToRgba, resolveLinkProps, resolveImage } from '../utils';

export default function BrandPortfolioSection({ block = {}, primaryColor, secondaryColor, enableAnimations, mediaFolders = {} }) {
    const { s, ref, anim, config, content } = useSectionSetup(block, { primaryColor, secondaryColor, enableAnimations });
    const columns = config.columns || 4;
    const cols = columns === 2 ? 'md:grid-cols-2' : columns === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2 lg:grid-cols-4';
    const items = content.items || [];
    const [hovered, setHovered] = useState(null);

    return (
        <SectionShell s={s} config={config} anim={anim} ref={ref} mediaFolders={mediaFolders}>
            <SectionHeader tag={content.tag} title={content.title} subtitle={content.subtitle} config={config} s={s} />
            <div className={`grid grid-cols-1 ${cols} gap-6`}>
                {items.map((item, i) => {
                    const logo = resolveImage(item, 'logo', mediaFolders) || item.logo_url;
                    const isHov = hovered === i;
                    return (
                        <div key={i}
                            className="relative group rounded-2xl border p-6 transition-all duration-500"
                            style={{
                                borderColor: isHov ? s.accent : hexToRgba(s.accent, 0.1),
                                backgroundColor: isHov ? hexToRgba(s.accent, 0.03) : 'transparent',
                                transform: isHov ? 'translateY(-4px)' : 'translateY(0)',
                            }}
                            onMouseEnter={() => setHovered(i)}
                            onMouseLeave={() => setHovered(null)}
                        >
                            {logo && (
                                <div className="h-12 flex items-center mb-4">
                                    <img src={logo} alt={item.name || ''} className="max-h-full max-w-[140px] object-contain" loading="lazy" />
                                </div>
                            )}
                            {!logo && item.name && (
                                <h3 className="text-lg font-bold mb-2" style={{ color: s.text }}>{item.name}</h3>
                            )}
                            {logo && item.name && (
                                <h3 className="text-sm font-semibold mb-1" style={{ color: s.text }}>{item.name}</h3>
                            )}
                            {item.industry && (
                                <span className="text-xs font-medium px-2 py-0.5 rounded-full mb-2 inline-block"
                                    style={{ backgroundColor: hexToRgba(s.accent, 0.1), color: s.accent }}>
                                    {item.industry}
                                </span>
                            )}
                            {item.description && (
                                <p className="text-sm leading-relaxed mt-2" style={{ color: s.textSub }}>{item.description}</p>
                            )}
                            {item.link && (
                                <a {...resolveLinkProps(item.link)} className="inline-flex items-center gap-1 text-sm font-medium mt-3 transition-colors"
                                    style={{ color: s.accent }}>
                                    {item.link_text || 'Conocer más'}
                                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7"/></svg>
                                </a>
                            )}
                        </div>
                    );
                })}
            </div>
        </SectionShell>
    );
}
